import { css } from '@/styled-system/css';

export const comboboxEmptyStateStyles = css.raw({
  paddingBlock: 'Combobox.Option.padding.vert',
  paddingInline: 'Combobox.Option.padding.horz',
  textStyle: 'body',
  color: 'Combobox.OptionLabel.text.label.default',
});
